package com.essntl.features.service.ui.addeditservice

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.spinner.EsSpinnerSize
import com.essntl.uikit.theme.esColorScheme
import com.mohamedrejeb.calf.core.LocalPlatformContext
import com.mohamedrejeb.richeditor.model.RichTextState

@Composable
fun AddEditServiceScreen(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    validation: AddEditServiceValidation,
    contactState: ContactState,
    contactEvent: (ContactEvent) -> Unit,
    richTextState: RichTextState,
) {
    val context = LocalPlatformContext.current
    val currentUserRole = remember(state.getProfile.data) {
        state.getProfile.data?.role
    }

    val isEdit by remember(state.service.value.id) {
        mutableStateOf(state.service.value.id.isNotBlank())
    }

    val canEdit = remember(currentUserRole) {
        currentUserRole == ProfileModel.Role.Admin ||
        currentUserRole == ProfileModel.Role.Supervisor ||
        currentUserRole == ProfileModel.Role.Owner
    }

    LaunchedEffect(state.addEditService) {
        if (state.addEditService.isSuccess) {
            onEvent(AddEditServiceEvent.SetEditMode(false))  // Changed from SetEditEnabled
            onEvent(AddEditServiceEvent.SetHasChanges(false))
        }
    }

    LaunchedEffect(state.service.value.id, state.addEditService.isSuccess) {
        validation.addEditServiceForm.reset()
        validation.addEditServiceForm.title.value = state.service.value.title
        validation.addEditServiceForm.category.value = state.service.value.category.orEmpty()
        onEvent(AddEditServiceEvent.SetHasChanges(false))
    }

    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .fillMaxSize(),
    ) {
        if (state.getService.isLoading) {
            EsSpinner(
                color = MaterialTheme.esColorScheme.iconPrimary,
                size = EsSpinnerSize.Large,
            )
        } else if (state.getService.isFailure) {
            Text(text = "Something went wrong")
        }

        EditServiceSection(
            state = state,
            onEvent = onEvent,
            richTextState = richTextState,
            validation = validation,
            enabled = if (isEdit) (state.isEditMode && canEdit) else true,  // Updated from isEditEnabled
            contactState = contactState,
            contactEvent = contactEvent,
            submitText = when {
                !isEdit -> "Add new service"
                state.isEditMode && state.hasChanges -> "Save"
                state.isEditMode && !state.hasChanges -> "Edit"  // Show Edit when in edit mode but no changes
                currentUserRole == null -> "Loading..."
                canEdit -> "Edit"
                else -> ""
            },
            onEnableEdit = {
                if (canEdit) {
                    onEvent(AddEditServiceEvent.SetEditMode(true))
                }
            },
            onSubmit = {
                if (isEdit) {
                    if (state.isEditMode && state.hasChanges) {
                        onEvent(AddEditServiceEvent.EditService(it, context))
                    }
                } else {
                    onEvent(AddEditServiceEvent.AddService(it, context))
                }
            },
            modifier = Modifier.fillMaxSize()
        )
    }
}
